/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  HealthControllerCheckReadinessQueryResponse,
  HealthControllerCheckReadiness503,
} from '../types/HealthControllerCheckReadiness.ts';

function getHealthCheckReadinessUrl() {
  const res = { method: 'GET', url: `/api/health/readiness` as const };
  return res;
}

/**
 * {@link /api/health/readiness}
 */
export async function healthCheckReadiness(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    HealthControllerCheckReadinessQueryResponse,
    ResponseErrorConfig<HealthControllerCheckReadiness503>,
    unknown
  >({ method: 'GET', url: getHealthCheckReadinessUrl().url.toString(), ...requestConfig });
  return res.data;
}
